import { render, staticRenderFns } from "./InstallmentPolicyCoverage.vue?vue&type=template&id=16034ce7&scoped=true&"
import script from "./InstallmentPolicyCoverage.vue?vue&type=script&lang=js&"
export * from "./InstallmentPolicyCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16034ce7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16034ce7')) {
      api.createRecord('16034ce7', component.options)
    } else {
      api.reload('16034ce7', component.options)
    }
    module.hot.accept("./InstallmentPolicyCoverage.vue?vue&type=template&id=16034ce7&scoped=true&", function () {
      api.rerender('16034ce7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/financial/installment-policy/InstallmentPolicyCoverage.vue"
export default component.exports